<div>
    <div class="row">
        <div class="col-md-12">
            <div class="card-box">
                <div v-show="!loading">
                    <div class="alert alert-success alert-dismissible fade show" role="alert" v-if="showSuccessMessage">
                        {{successMessage}}
                        <button type="button" class="close" aria-label="Close" @click="onSuccessMessageCloseClick">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="alert alert-danger alert-dismissible fade show" role="alert" v-if="showErrorMessage">
                        {{errorMessage}}
                        <button type="button" class="close" aria-label="Close" @click="errorMessageCloseClick">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>

                    <from-date-to-date-pickers  :title="'Select Date Range'"
                                                :fromDate="startDate"
                                                :toDate="endDate"
                                                :elementId="'customerDocumentBatchDateSelect'"
                                                :dateFormat="'DD/MM/YYYY'"
                                                @clearDatePicker="onDatePickerRangeClearClick"
                                                @fromDateSelected="onFromDateSelect"
                                                @toDateSelected="onToDateSelect"></from-date-to-date-pickers>
                    <br>
                    <div class="table-responsive pt-4" v-if="!loading">
                        <table class="table table-hover mb-0">
                            <thead>
                            <tr>
                                <th>Date</th>
                                <th></th>

                            </tr>
                            </thead>
                            <tbody>
                            <tr v-for="(document, index) in documents" :key="index">
                                <td>{{document.name}}</td>
                                <td>
                                    <button class="btn btn-link" @click="downloadSingleBatch(document)">Download</button>
                                </td>
                            </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
                <loading-spinner :showSpinner="loading"></loading-spinner>
            </div>
        </div>
    </div>
</div>
